/*
  Block our klayvio email popup from appearing on the page: https://glucoboss.com.au/pages/glp1-nutrition-plan
*/
if (document.body.classList.contains('page-glp1-meal-plan')) {
    document.querySelectorAll('[id^="NewsletterPopup-"]').forEach(el => el.remove());
}
